import { render } from "./AttendeeWalletTab.vue?vue&type=template&id=08021a7c&scoped=true"
import script from "./AttendeeWalletTab.vue?vue&type=script&lang=js"
export * from "./AttendeeWalletTab.vue?vue&type=script&lang=js"

import "./AttendeeWalletTab.vue?vue&type=style&index=0&id=08021a7c&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08021a7c"]])

export default __exports__